module.exports = __webpack_public_path__ + "img/signs2.d5f66320.jpg";